import React, { useEffect, useState } from 'react';
import styles from './Filter.module.css';
import Select from "react-select";
import { store } from '../../../../store';

const Filter = (props) => {
  const {
    onChangeFilter = () => { },
    orderTypes = [],
  } = props;

  const [type, setType] = useState([]);

  useEffect(() => {
    const { teamshareFilterPersist } = store.getState() || {};
    const { revenueCenters } = teamshareFilterPersist?.data || {};
    setType(revenueCenters);
  }, []);

  const customStyles = {
    control: (base, state) => ({
      ...base,
      background: "#ffffff",
      color: "white",
      borderColor: state.isFocused ? "white" : "white",
      boxShadow: state.isFocused ? null : null,
      width: "38vw",
      height: "6vh",
      minHeight: "6vh",
      borderRadius: "0.5vh",
      borderColor: "gray",
      borderWidth: "0.1vh",
      "&:hover": {
        borderColor: state.isFocused ? "white" : "white"
      },
      overflow: 'scroll',
      fontSize: "2.2vh",
      padding: "0vh"
    })
  };

  const handleChange = selectedOption => {
    setType(selectedOption);
    onChangeFilter(selectedOption);
  };

  return (
    <Select
      value={type}
      isMulti
      styles={customStyles}
      options={orderTypes}
      onChange={handleChange}
      isSearchable={false}
      placeholder="Please Select"
    />
  );

}

export default Filter;
